import React from 'react';
// Placeholder image for the "À Propos" page
import AboutImage from '../../img/pfp.webp';

const Apropos = () => {
  return (
    <main id='apropos'>
      <div className="photo-container">
        <img src={AboutImage} alt="À Propos" />
        <p>Tahïn Pierdet, Tahin.raw &ensp;Photo: <a href="https://rastagraphe.com/" target='_blank' rel='noreferrer'>@rastagrapghe974</a></p>
      </div>
      
      <div className="content">
        <h1>À Propos</h1>
        
        <p>La photographie a commencé pour moi avec un Lumix compact. À ce moment-là, je capture tout ce qui m'entoure, tout ce qui m'émerveille. Des détails du jardin de Monet et de sa maison, aux belles campagnes autour de moi. J'aime penser que la beauté se cache partout ; parfois enfouie, ou simplement offerte à nos yeux.</p>

        <p>Artiste et musicien, je m'appelle Tahïn et je suis né sur une île magnifique : la Réunion. Depuis plus de 15 ans j'ai élu domicile dans la campagne toulousaine. Avec le temps, mon regard s'est affiné. Cette passion m'a donné envie d'aller plus loin : explorer la photographie de façon plus professionnelle, plonger pleinement dans l'univers de l'audiovisuel.</p>

        <p>C'est au Connexion Live que j'ai fait mes premières photos de concert, porté par mon attrait pour la musique et entouré d'amis musiciens et photographes. Là, mes deux passions se sont rencontrées. Aussi, suite à une formation de télépilote, le drone m'a offert de nouvelles perspectives en photo comme en vidéo.</p>

        <p>Aujourd'hui, la photo m'emmène aussi bien au cœur des festivals que sur les petites scènes, à la rencontre d'artistes et de moments uniques. Elle reste aussi présente dans mon quotidien, dans la nature et les instants plus simples. Chaque projet et chaque rencontre sont pour moi l'occasion de partager un regard, de raconter une histoire en images, avec créativité et authenticité. Je serai heureux d'accompagner les vôtres.</p>
      </div>
    </main>
  );
}
 
export default Apropos;